import _styled from "styled-components";
import { memo, useCallback, useEffect, useState } from 'react';
import { useAnalytics, useImageBlob, useIsEmployerApp, useNavigationContext, useResponsiveBreakPoints } from '@restworld/utils-common';
import { useSpringRef, useChain } from '@react-spring/web';
import { BaseModal } from '../../../';
import HamburgerComponent from './hamburger-component';
import { Avatar } from 'flowbite-react';
import NavMenuContent from './nav-menu-content';
import { useIntercom } from 'react-use-intercom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DesktopOverlayNav = /*#__PURE__*/memo(function (props) {
  var _props$background = props.background,
      background = _props$background === void 0 ? 'white' : _props$background,
      isAuthenticated = props.isAuthenticated,
      avatarImage = props.avatarImage,
      isNavOverlay = props.isNavOverlay,
      navOverlayToggler = props.navOverlayToggler,
      _onStartLogin = props.onStartLogin,
      _onStartSignup = props.onStartSignup,
      workerInfo = props.workerInfo,
      onShowUploadCvModal = props.onShowUploadCvModal;

  var _useState = useState(),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var _useAnalytics = useAnalytics(),
      trackEvent = _useAnalytics.trackEvent;

  var _useIsEmployerApp = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp.isEmployerApp;

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var _useIntercom = useIntercom(),
      update = _useIntercom.update;

  var onSelectActiveItem = useCallback(function (value) {
    return setActiveItem(value);
  }, []);
  var onClickMenuToggler = useCallback(function () {
    navOverlayToggler(function (prev) {
      return !prev;
    });
    onSelectActiveItem();
  }, [navOverlayToggler, onSelectActiveItem]);
  var navRef = useSpringRef();
  var liRef = useSpringRef();
  var subRef = useSpringRef(); // On showMenu, start with nav animation, then nav items

  useChain(isNavOverlay ? [navRef, liRef] : [liRef, navRef], [0, isNavOverlay ? 0.4 : 0.6]); // When sub-items are shown, close liRef and open subRef

  useChain(activeItem !== null && activeItem !== void 0 && activeItem.subItems ? [liRef, subRef] : [subRef, liRef], [0, activeItem !== null && activeItem !== void 0 && activeItem.subItems ? 0.4 : 0.6]);
  var avatarImageURL = useImageBlob(avatarImage);
  useEffect(function () {
    if (isEmployerApp || router.pathname.includes('/locale')) return;
    update({
      hideDefaultLauncher: isNavOverlay
    });
  }, [isEmployerApp, isNavOverlay, router.pathname, update]);
  if (!isDesktop) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_StyledDiv, {
      children: /*#__PURE__*/_jsxs(_StyledDiv2, {
        onClick: function onClick() {
          onClickMenuToggler();
        },
        children: [isAuthenticated ? /*#__PURE__*/_jsx(_StyledAvatar, {
          size: "sm",
          alt: "avatar-img",
          rounded: true,
          color: "purple",
          img: avatarImageURL
        }) : null, /*#__PURE__*/_jsx(HamburgerComponent, {
          background: background,
          isOpen: isNavOverlay
        })]
      })
    }), /*#__PURE__*/_jsx(BaseModal, {
      open: isNavOverlay,
      onClose: function onClose() {
        return onClickMenuToggler();
      },
      variant: "right",
      noPadding: true,
      hideHeader: true,
      footer: null,
      closeIcon: null,
      modalStyles: [{
        "borderTopLeftRadius": "0px",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
        "@media (min-width: 1024px)": {
          "width": "288px",
          "minWidth": "0px",
          "maxWidth": "288px",
          "paddingBottom": "0px"
        }
      }],
      children: /*#__PURE__*/_jsx(NavMenuContent, {
        onCloseMenu: onClickMenuToggler,
        avatarImageURL: avatarImageURL,
        workerInfo: workerInfo,
        onStartSignup: function onStartSignup() {
          _onStartSignup();

          trackEvent('initiate_create_account', {
            origin: 'sidebar'
          });
        },
        onStartLogin: function onStartLogin() {
          _onStartLogin();

          trackEvent('initiate_signin', {
            login_state: false,
            user_type: null
          });
        },
        onShowUploadCvModal: onShowUploadCvModal
      })
    })]
  });
});
export var TopItem = /*#__PURE__*/_styled.div.withConfig({
  displayName: "desktop-overlay-nav__TopItem",
  componentId: "sc-1xhb68c-0"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingLeft": "46px",
  "paddingRight": "2rem"
}, function (_ref) {
  var isHeader = _ref.isHeader;
  return isHeader ? {
    "paddingTop": "3rem"
  } : {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv",
  componentId: "sc-1xhb68c-1"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "desktop-overlay-nav___StyledDiv2",
  componentId: "sc-1xhb68c-2"
})({
  "display": "flex",
  "width": "fit-content",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var _StyledAvatar = /*#__PURE__*/_styled(Avatar).withConfig({
  displayName: "desktop-overlay-nav___StyledAvatar",
  componentId: "sc-1xhb68c-3"
})({
  "minWidth": "32px",
  ":hover": {
    "cursor": "pointer"
  }
});